import {getProviderColors} from '../helpers/providers.js';

const md5 = require('md5');

const initialState = {
  aanbieders: [],
  aclOperators: [],
  gebieden: [],
  zones: [],
  vehicle_types: [],
  // NL-wide account (admin / ADMIN organisation), resolved from the ACL. Kept in
  // metadata so request builders that only receive `metadata` (e.g.
  // createFilterparameters) can scope requests without the full state.
  is_admin: false,
  metadata_loaded: false,
  zones_loaded: false
}

// utility function that creates a color palette
// background: https://mika-s.github.io/javascript/colors/hsl/2017/12/05/generating-random-colors-in-javascript.html
const generateHslaColors = (amount) => {
  
  let colors = []
  let huedelta = Math.trunc(360 / (amount+1))
  let alpha = 1.0

  for (let i = 0; i < amount; i++) {
    let hue = i * huedelta
    let lightness = i % 2 === 0 ? 35 : 65;
    let saturation = i % 2 === 1 ? 40 : 60;
    colors.push(`hsla(${hue},${saturation}%,${lightness}%,${alpha})`)
  }

  return colors
}

export default function filter(state = initialState, action) {
  switch(action.type) {
    case 'SET_AANBIEDERS': {
      let current = state.aanbieders ? state.aanbieders: [];

      // Resolve color per provider with this priority:
      //   1. Hardcoded brand color from `getProviderColors()` (visual consistency
      //      for known providers).
      //   2. `color` returned by the operators API (covers new providers we
      //      have not yet added to the local map).
      //   3. Generated HSLA fallback so every provider always has a color.
      const colors = generateHslaColors(action.payload.length)
      const providerColors = getProviderColors();
      const aanbieders = action.payload.map((aanbieder,idx)=>{
        const localColor = providerColors[aanbieder.system_id];
        const apiColor = aanbieder && aanbieder.color ? aanbieder.color : null;
        const color = localColor || apiColor || colors[idx];
        return Object.assign({}, aanbieder, {color: color});
      })
      
      if(md5(JSON.stringify(current))===md5(JSON.stringify(aanbieders))) { return state; }
      
      return {
        ...state,
        aanbieders
      }
    }
    case 'SET_ACL_OPERATORS': {
      const aclOperators = action.payload || [];
      const current = state.aclOperators || [];

      if (md5(JSON.stringify(current)) === md5(JSON.stringify(aclOperators))) {
        return state;
      }

      return {
        ...state,
        aclOperators,
      };
    }
    case 'SET_GEBIEDEN': {
      let current = state.gebieden ? state.gebieden: [];
    
      if(md5(JSON.stringify(current))===md5(JSON.stringify(action.payload))) { return state; }
    
      return {
        ...state,
        gebieden: action.payload,
      }
    }
    
    case 'SET_ZONES': {
      let current = state.zones ? state.zones: [];
    
      if(md5(JSON.stringify(current))===md5(JSON.stringify(action.payload))) { return state; }

      return {
          ...state,
          zones: action.payload,
      };
    }
    
    case 'CLEAR_ZONES': {
      return {
          ...state,
          zones: [],
          zones_loaded: false,
      };
    }

    case 'SET_VEHICLE_TYPES': {
      let current = state.vehicle_types ? state.vehicle_types: [];
    
      if(JSON.stringify(md5(current))===JSON.stringify(md5(action.payload))) { return state; }

      return {
          ...state,
          vehicle_types: action.payload,
      };
    }

    case 'SET_METADATA_IS_ADMIN': {
      const is_admin = action.payload === true;
      if (state.is_admin === is_admin) { return state; }

      return {
        ...state,
        is_admin,
      };
    }

    case 'SET_METADATA_LOADED': {
      return {
          ...state,
          metadata_loaded: action.payload,
      };
    }

    case 'SET_ZONES_LOADED': {
      return {
          ...state,
          zones_loaded: action.payload,
      };
    }
    
    case 'LOGIN':
    case 'LOGOUT': {
      console.log('login/logout - reset metadata')
      
      return initialState;
    }

    default:
      return state;
  }
}
